import React, { useContext, useId, useRef, useState } from "react";
import "./Confirm.css";
import { Context } from "../../context/Context";
import { translations } from "../../utils/lang";
import { Button } from "../ui";
import { useModalLayer } from "./modalHooks";

export const InputModal = ({ label, placeholder, onConfirm, onCancel }) => {
  const { lang } = useContext(Context);
  const [value, setValue] = useState("");
  const titleId = useId();
  const dialogRef = useRef(null);

  useModalLayer(true, { containerRef: dialogRef, onEscape: onCancel });

  const handleConfirm = () => {
    // An empty/whitespace value cancels. The missing return used to fall
    // through and confirm the blank value as well.
    if (!value.trim()) {
      onCancel();
      return;
    }
    onConfirm(value);
  };

  return (
    <div className="confirm-container">
      <div
        ref={dialogRef}
        className="confirm"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div>
          <h4 id={titleId}>{label || translations[lang].deleteModal.areyousure}</h4>

          <textarea
            autoFocus
            aria-labelledby={titleId}
            rows="4"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder || ""}
            className="confirm-input"
          />
        </div>

        <div className="confirm-btn">
          <Button variant="primary" appearance="filled" onClick={handleConfirm}>
            {translations[lang].deleteModal.yes}
          </Button>
        </div>

        <div className="cancel-confirm-btn">
          <Button variant="danger" appearance="soft" onClick={onCancel}>
            {translations[lang].deleteModal.no}
          </Button>
        </div>
      </div>
    </div>
  );
};